import { useEffect, useState } from 'react';
import FormulariosEntidadeService from 'services/FormulariosEntidadeService';
import { obterBloqueio } from 'utils/bloqueios';

const useBloqueio = (funcionalidade) => {
  const [estado, setEstado] = useState({
    bloqueado: false,
    termino: null,
    mensagem: '',
    carregando: true,
  });

  useEffect(() => {
    let ativo = true;

    (async () => {
      const configuracao = await FormulariosEntidadeService.ObterConfiguracaoFormulario()
        .catch(() => null);

      if (!ativo) return;

      setEstado({
        ...obterBloqueio(configuracao, funcionalidade),
        carregando: false,
      });
    })();

    return () => { ativo = false; };
  }, [funcionalidade]);

  return estado;
};

export default useBloqueio;
